const userContentCompletionStatus = {
  Unknown: 'Unknown',
  Completed: 'Completed',
  Failed: 'Failed',
  InProgress: 'InProgress',
  Tasked: 'Tasked'
};

export default userContentCompletionStatus;


// WEBPACK FOOTER //
// ./src/constants/user-content-completion-status.js